/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimFolder,
  ClaimFolderListResponse,
  CreateClaimFolderRequest,
  ErrorEnvelope,
  Problem,
  UpdateClaimFolderRequest,
} from '../models/index';
import {
    ClaimFolderFromJSON,
    ClaimFolderToJSON,
    ClaimFolderListResponseFromJSON,
    ClaimFolderListResponseToJSON,
    CreateClaimFolderRequestFromJSON,
    CreateClaimFolderRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateClaimFolderRequestFromJSON,
    UpdateClaimFolderRequestToJSON,
} from '../models/index';

export interface CreateClaimFolderOperationRequest {
    createClaimFolderRequest: CreateClaimFolderRequest;
}

export interface DeleteClaimFolderRequest {
    id: number;
}

export interface GetClaimFolderRequest {
    id: number;
}

export interface GetClaimFoldersRequest {
    includeClaimCount?: boolean;
}

export interface UpdateClaimFolderOperationRequest {
    id: number;
    updateClaimFolderRequest: UpdateClaimFolderRequest;
}

/**
 * ClaimFoldersApi - interface
 * 
 * @export
 * @interface ClaimFoldersApiInterface
 */
export interface ClaimFoldersApiInterface {
    /**
     * 
     * @summary Create a new claim folder
     * @param {CreateClaimFolderRequest} createClaimFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimFoldersApiInterface
     */
    createClaimFolderRaw(requestParameters: CreateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>>;

    /**
     * Create a new claim folder
     */
    createClaimFolder(requestParameters: CreateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder>;

    /**
     * 
     * @summary Delete a claim folder (claims are unassigned, not deleted)
     * @param {number} id Claim folder ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimFoldersApiInterface
     */
    deleteClaimFolderRaw(requestParameters: DeleteClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a claim folder (claims are unassigned, not deleted)
     */
    deleteClaimFolder(requestParameters: DeleteClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a claim folder by ID
     * @param {number} id Claim folder ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimFoldersApiInterface
     */
    getClaimFolderRaw(requestParameters: GetClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>>;

    /**
     * Get a claim folder by ID
     */
    getClaimFolder(requestParameters: GetClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder>;

    /**
     * 
     * @summary Get all claim folders for the company
     * @param {boolean} [includeClaimCount] When true, each folder includes the number of claims assigned to it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimFoldersApiInterface
     */
    getClaimFoldersRaw(requestParameters: GetClaimFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolderListResponse>>;

    /**
     * Get all claim folders for the company
     */
    getClaimFolders(requestParameters: GetClaimFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolderListResponse>;

    /**
     * 
     * @summary Update a claim folder
     * @param {number} id Claim folder ID
     * @param {UpdateClaimFolderRequest} updateClaimFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimFoldersApiInterface
     */
    updateClaimFolderRaw(requestParameters: UpdateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>>;

    /**
     * Update a claim folder
     */
    updateClaimFolder(requestParameters: UpdateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder>;

}

/**
 * 
 */
export class ClaimFoldersApi extends runtime.BaseAPI implements ClaimFoldersApiInterface {

    /**
     * Create a new claim folder
     */
    async createClaimFolderRaw(requestParameters: CreateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>> {
        if (requestParameters['createClaimFolderRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimFolderRequest',
                'Required parameter "createClaimFolderRequest" was null or undefined when calling createClaimFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-folders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimFolderRequestToJSON(requestParameters['createClaimFolderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFolderFromJSON(jsonValue));
    }

    /**
     * Create a new claim folder
     */
    async createClaimFolder(requestParameters: CreateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder> {
        const response = await this.createClaimFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a claim folder (claims are unassigned, not deleted)
     */
    async deleteClaimFolderRaw(requestParameters: DeleteClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-folders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a claim folder (claims are unassigned, not deleted)
     */
    async deleteClaimFolder(requestParameters: DeleteClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimFolderRaw(requestParameters, initOverrides);
    }

    /**
     * Get a claim folder by ID
     */
    async getClaimFolderRaw(requestParameters: GetClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-folders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFolderFromJSON(jsonValue));
    }

    /**
     * Get a claim folder by ID
     */
    async getClaimFolder(requestParameters: GetClaimFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder> {
        const response = await this.getClaimFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claim folders for the company
     */
    async getClaimFoldersRaw(requestParameters: GetClaimFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolderListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeClaimCount'] != null) {
            queryParameters['includeClaimCount'] = requestParameters['includeClaimCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-folders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFolderListResponseFromJSON(jsonValue));
    }

    /**
     * Get all claim folders for the company
     */
    async getClaimFolders(requestParameters: GetClaimFoldersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolderListResponse> {
        const response = await this.getClaimFoldersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a claim folder
     */
    async updateClaimFolderRaw(requestParameters: UpdateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFolder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimFolder().'
            );
        }

        if (requestParameters['updateClaimFolderRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimFolderRequest',
                'Required parameter "updateClaimFolderRequest" was null or undefined when calling updateClaimFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-folders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimFolderRequestToJSON(requestParameters['updateClaimFolderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFolderFromJSON(jsonValue));
    }

    /**
     * Update a claim folder
     */
    async updateClaimFolder(requestParameters: UpdateClaimFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFolder> {
        const response = await this.updateClaimFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
